// jQuery e plugins
import $ from 'jquery'
window.$ = window.jQuery = $
import 'jquery-ui/ui/widgets/autocomplete.js'
import 'jquery-ui/ui/widgets/datepicker.js'
require('jquery-mask-plugin/dist/jquery.mask.js')
require('slick-carousel/slick/slick.min.js')

// Cookies
window.Cookies = require('js-cookie')

// código local
import configBase from './modulos/base'
import configAutocomplete from './modulos/autocomplete'
import configReordenar from './modulos/reordenar'
import configMenu from './modulos/menu'
import configNotificacoes from './modulos/notificacoes'
import configCalendario from './modulos/calendario'
import configImagens from './modulos/imagens'
import configCep from './modulos/cep'
import configMascaras from './modulos/mascaras'
import configPicker from './modulos/picker'
import configSelecao from './modulos/selecao'
import configUpdateSelect from './modulos/update-select'
import configUtil from './modulos/util'
import configFiltro from './modulos/filtro'

// Vue
import Vue from 'vue'
window.Vue = Vue

function init() {
	configBase()
	configReordenar()
	configMenu()
	configNotificacoes()
	configAutocomplete()
	configCalendario()
	configCep()
	configImagens()
	configMascaras()
	configPicker()
	configSelecao()
	configUpdateSelect()
	configUtil()
	configFiltro()
}

// inicializa tudo
init()
